// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-details__content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 22px 24px 24px 0;
	gap: 24px;
}

.orders-details__back {
	width: 45px;
	height: 45px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f2f2f2;
	cursor: pointer;
}

.orders-details__content {
	display: grid;
	grid-template-columns: calc(100% - 344px) 320px;
	grid-template-rows: 100%;
	width: 100%;
	padding: 24px;
	background-color: #f2f2f2;
	border-radius: 10px;
	gap: 24px;
}

.order-details__main-information {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.order-details__information-block {
	width: 100%;
	background-color: #ffffff;
	border-radius: 10px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.order-details__order-block-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.order-details__order-information-title {
	font-size: 24px;
	line-height: 30px;
	font-weight: 500;
	color: #191919;
}

.order-details__order-status {
	display: flex;
	align-items: center;
	gap: 8px;
}

.order-details__order-status-indicator {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #117627;
}

.order-details__order-status-indicator.error {
	background-color: #f44336;
}

.order-details__order-status-text {
	font-size: 14px;
	line-height: 17px;
	color: #666666;
}

.order-details__order-info-text-block {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	grid-template-rows: 1fr;
}

.order-details__order-info-text {
	font-size: 16px;
	line-height: 24px;
	color: #666666;
}

.order-details__order-info-text-value {
	font-weight: 500;
	color: #191919;
}

.order-details__order-date {
	font-size: 14px;
	line-height: 17px;
	color: #666666;
	margin-top: -4px;
}

.order-details__customer-orders-details {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr;
	gap: 16px;
	background-color: #ffffff;
	padding: 24px;
	border-radius: 10px;
}

.order-details__customer-orders-details-block {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.order-details__info-fields-list {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.order-details__shipment-details {
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: white;
	padding: 24px;
	border-radius: 10px;
	gap: 4px;
	height: fit-content;
}

.order-details__shipment-details-icon {
	width: 68px;
	height: 68px;
	background-color: #0085ff;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	margin: 0 auto;
}

.order-details__shipment-details-divider {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100% + 82px);
	margin-left: -41px;
	gap: 4px;
}

.order-details__divider-circle {
	width: 34px;
	height: 34px;
	border-radius: 50%;
	background-color: #f2f2f2;
}

.order-details__divider-dash {
	width: 10px;
	height: 1px;
	background-color: #f2f2f2;
}

.order-details__shipment-details-title {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
	font-weight: 600;
}

.order-details__shipment-details-header {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
}

.order-details__shipment-details-block {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 10px;
}

.order-details__shipment-details-block-title {
	font-size: 14px;
	line-height: 17px;
	color: #191919;
	font-weight: 400;
}

.order-details__shipment-details-table {
	width: 100%;
	border-collapse: collapse;
	border: none;
}

.order-details__shipment-details-table tr {
	border-top: none !important;
}

.order-details__shipment-details-table-body {
	border: none;
}

.order-details__shipment-details-table-label {
	font-size: 14px;
	line-height: 17px;
	color: #666666;
	padding-left: 0 !important;
}

.order-details__shipment-details-table-value {
	font-size: 14px;
	line-height: 17px;
	color: #191919;
	font-weight: 600;
	text-align: end;
	padding-right: 0 !important;
}

.order-details__shipment-details-note {
	font-size: 14px;
	line-height: 17px;
	color: #191919;
	border: 1px solid #e6e6e6;
	border-radius: 10px;
	padding: 8px;
}

.order-details__shipment-details-textarea {
	height: 88px;
	resize: none;
	padding: 8px;
	font-size: 14px;
	line-height: 17px;
	color: #191919;
	margin-top: 16px;
}

.order-details__shipment-details-textarea::placeholder {
	color: #666666;
}

.order-details__shipment-details-textarea:hover,
.order-details__shipment-details-textarea:focus {
	border: 1px solid #e6e6e6;
	box-shadow: none;
}

.order-details__fulfillment-details-block {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.order-details__fulfillment-details-title {
	font-size: 24px;
	line-height: 30px;
	font-weight: 500;
	color: #191919;
}

.order-details__fulfillment-details-table-wrapper {
	background-color: #ffffff;
	width: 100%;
	padding: 24px;
	border-radius: 10px;
}

.order-details__fulfillment-details-table-wrapper tr {
	height: 64px;
}

.order-details__fulfillment-details-table-wrapper tr th {
	font-size: 16px;
	line-height: 20px;
	color: #666666;
	font-weight: 400;
}

.order-details__fulfillment-details-table-wrapper tr td {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
	font-weight: 400;
}

.order-details__fulfillment-two-rows {
	display: flex;
	flex-direction: column;
	font-size: 14px;
	line-height: 17px;
	color: #666666;
}

.order-details__fulfillment-two-rows span {
	font-size: 16px;
	line-height: 20px;
	color: #191919;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/OrderDetails/OrderDetails.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,+CAA+C;CAC/C,wBAAwB;CACxB,WAAW;CACX,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,uBAAuB;CACvB,SAAS;CACT,yBAAyB;CACzB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,wBAAwB;CACxB,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf","sourcesContent":[".orders-details__content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 22px 24px 24px 0;\n\tgap: 24px;\n}\n\n.orders-details__back {\n\twidth: 45px;\n\theight: 45px;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: #f2f2f2;\n\tcursor: pointer;\n}\n\n.orders-details__content {\n\tdisplay: grid;\n\tgrid-template-columns: calc(100% - 344px) 320px;\n\tgrid-template-rows: 100%;\n\twidth: 100%;\n\tpadding: 24px;\n\tbackground-color: #f2f2f2;\n\tborder-radius: 10px;\n\tgap: 24px;\n}\n\n.order-details__main-information {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n}\n\n.order-details__information-block {\n\twidth: 100%;\n\tbackground-color: #ffffff;\n\tborder-radius: 10px;\n\tpadding: 24px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.order-details__order-block-title {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.order-details__order-information-title {\n\tfont-size: 24px;\n\tline-height: 30px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.order-details__order-status {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 8px;\n}\n\n.order-details__order-status-indicator {\n\twidth: 10px;\n\theight: 10px;\n\tborder-radius: 50%;\n\tbackground-color: #117627;\n}\n\n.order-details__order-status-indicator.error {\n\tbackground-color: #f44336;\n}\n\n.order-details__order-status-text {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n}\n\n.order-details__order-info-text-block {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 16px;\n\tgrid-template-rows: 1fr;\n}\n\n.order-details__order-info-text {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #666666;\n}\n\n.order-details__order-info-text-value {\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.order-details__order-date {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n\tmargin-top: -4px;\n}\n\n.order-details__customer-orders-details {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgrid-template-rows: 1fr;\n\tgap: 16px;\n\tbackground-color: #ffffff;\n\tpadding: 24px;\n\tborder-radius: 10px;\n}\n\n.order-details__customer-orders-details-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.order-details__info-fields-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n}\n\n.order-details__shipment-details {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: white;\n\tpadding: 24px;\n\tborder-radius: 10px;\n\tgap: 4px;\n\theight: fit-content;\n}\n\n.order-details__shipment-details-icon {\n\twidth: 68px;\n\theight: 68px;\n\tbackground-color: #0085ff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 50%;\n\tmargin: 0 auto;\n}\n\n.order-details__shipment-details-divider {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: calc(100% + 82px);\n\tmargin-left: -41px;\n\tgap: 4px;\n}\n\n.order-details__divider-circle {\n\twidth: 34px;\n\theight: 34px;\n\tborder-radius: 50%;\n\tbackground-color: #f2f2f2;\n}\n\n.order-details__divider-dash {\n\twidth: 10px;\n\theight: 1px;\n\tbackground-color: #f2f2f2;\n}\n\n.order-details__shipment-details-title {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n\tfont-weight: 600;\n}\n\n.order-details__shipment-details-header {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 12px;\n}\n\n.order-details__shipment-details-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 10px;\n}\n\n.order-details__shipment-details-block-title {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #191919;\n\tfont-weight: 400;\n}\n\n.order-details__shipment-details-table {\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tborder: none;\n}\n\n.order-details__shipment-details-table tr {\n\tborder-top: none !important;\n}\n\n.order-details__shipment-details-table-body {\n\tborder: none;\n}\n\n.order-details__shipment-details-table-label {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n\tpadding-left: 0 !important;\n}\n\n.order-details__shipment-details-table-value {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #191919;\n\tfont-weight: 600;\n\ttext-align: end;\n\tpadding-right: 0 !important;\n}\n\n.order-details__shipment-details-note {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #191919;\n\tborder: 1px solid #e6e6e6;\n\tborder-radius: 10px;\n\tpadding: 8px;\n}\n\n.order-details__shipment-details-textarea {\n\theight: 88px;\n\tresize: none;\n\tpadding: 8px;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #191919;\n\tmargin-top: 16px;\n}\n\n.order-details__shipment-details-textarea::placeholder {\n\tcolor: #666666;\n}\n\n.order-details__shipment-details-textarea:hover,\n.order-details__shipment-details-textarea:focus {\n\tborder: 1px solid #e6e6e6;\n\tbox-shadow: none;\n}\n\n.order-details__fulfillment-details-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.order-details__fulfillment-details-title {\n\tfont-size: 24px;\n\tline-height: 30px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.order-details__fulfillment-details-table-wrapper {\n\tbackground-color: #ffffff;\n\twidth: 100%;\n\tpadding: 24px;\n\tborder-radius: 10px;\n}\n\n.order-details__fulfillment-details-table-wrapper tr {\n\theight: 64px;\n}\n\n.order-details__fulfillment-details-table-wrapper tr th {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #666666;\n\tfont-weight: 400;\n}\n\n.order-details__fulfillment-details-table-wrapper tr td {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n\tfont-weight: 400;\n}\n\n.order-details__fulfillment-two-rows {\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n}\n\n.order-details__fulfillment-two-rows span {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: #191919;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
